import { useRef, useCallback, useState, useEventListener } from 'sb-hooks'
import throttle from 'common/helpers/actions/throttle'


const useLoadMore = ({ element, limit = 0, initialOffset = 0, offsetBottom = 0 }) => {
  const isFetching  = useRef(false)
  const canLoadMore = useRef(true)

  const [ offset, setOffset ] = useState(initialOffset)

  const setFetching     = useCallback((isFetchingValue) => isFetching.current = isFetchingValue, [])
  const setCanLoadMore  = useCallback((canLoadMoreValue) => canLoadMore.current = canLoadMoreValue, [])

  const resetOffset = useCallback(() => {
    setCanLoadMore(true)
    setOffset(initialOffset)
  }, [ initialOffset, setCanLoadMore ])

  const handleScroll = useCallback(throttle(() => {
    if (element.current) {
      const { bottom } = element.current.getBoundingClientRect()

      const shouldLoadMore = (
        bottom <= window.innerHeight + offsetBottom
        && !isFetching.current
        && canLoadMore.current
      )

      if (shouldLoadMore) {
        setOffset(offset + limit)
      }
    }
  }, 150), [ element, offsetBottom, limit, offset ])

  useEventListener('scroll', handleScroll)

  return {
    offset,
    resetOffset,
    setFetching,
    setCanLoadMore,
  }
}


export default useLoadMore
